<template functional>
  <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 380.19 380.19" style="stroke-miterlimit:10;stroke-width:14.19px;"><rect class="cls-1" x="7.09" y="7.09" width="366" height="366" rx="43.54"/><line class="cls-1" x1="7.09" y1="96.27" x2="373.09" y2="96.27"/><rect x="44.84" y="48.87" width="68.35" height="14.17"/><rect x="128.41" y="48.87" width="68.35" height="14.17"/></svg>
</template>

<script>
export default {}
</script>
